import React, { useRef, useState } from 'react';
import {
  bool, string, arrayOf, any, oneOfType, number, shape, array
} from 'prop-types';
import { Image } from '@thd-olt-component-react/image';
import { Hotspot } from './Hotspot';
import { HotspotToggle } from './sub-components/HotspotToggle';

const MAX_DISPLAYED_HOTSPOTS_COUNT = 10;

const ContainerHotspots = (props) => {

  const {
    hotspots,
    products,
    skus,
    collectionImage,
    requestKey,
    storeId,
    channel
  } = props;

  const [shouldHideHotspots, setShouldHideHotspots] = useState(false);

  const onToggle = (hidden) => {
    setShouldHideHotspots(!hidden);
  };

  const openHotspotRef = useRef();
  const uniqueHotspotItemIDs = [];
  const uniqueHotspots = [];

  if (hotspots) {
    hotspots.forEach((hotspot) => {
      const { itemId } = hotspot;
      if (itemId && uniqueHotspotItemIDs.indexOf(itemId) === -1) {
        uniqueHotspotItemIDs.push(itemId);
        uniqueHotspots.push(hotspot);
      }
    });
  }

  let displayedHotspotsCount = 0;

  const hideOthers = (event, tooltipRef) => {
    const eventTargetName = event?.target?.nodeName;
    // if the hotspot is opened, and we click on it via TAB -> ENTER, then simulate the tag click
    if (event && openHotspotRef && openHotspotRef.current && eventTargetName === 'BUTTON') {
      openHotspotRef.current.click();
    }

    openHotspotRef.current = openHotspotRef.current ? null : tooltipRef;
  };

  return (
    <>
      <Image
        className="anchor-image"
        src={collectionImage}
        alt="main-product-image"
        height="400"
        width="400"
        data-testid="anchor-image"
      />
      {
        uniqueHotspots
        && products
        && (
          <HotspotToggle
            onToggle={onToggle}
            channel={channel}
          />
        )
      }
      {
        uniqueHotspots
        && products
        && !shouldHideHotspots
        && uniqueHotspots.map((hotspot) => {
          const {
            hsXPosition,
            hsYPosition,
            itemId,
          } = hotspot;

          const sku = products.find((element) => Number(element.itemId) === Number(itemId));

          if (sku && displayedHotspotsCount < MAX_DISPLAYED_HOTSPOTS_COUNT) {
            displayedHotspotsCount += 1;

            if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined') {
              LIFE_CYCLE_EVENT_BUS.trigger('product-hotspots.render', {
                channel,
                itemID: itemId,
                leftPosition: hsXPosition,
                sku,
                topPosition: hsYPosition
              });
            }

            return (
              <Hotspot
                apiKey={requestKey}
                hsXPosition={hsXPosition}
                hsYPosition={hsYPosition}
                itemID={itemId}
                key={itemId}
                onClick={hideOthers}
                product={sku}
                productSkus={skus}
                storeId={storeId}
                channel={channel}
              />
            );
          }

          return null;
        })
      }
    </>
  );
};

ContainerHotspots.displayName = 'ContainerHotspots';

ContainerHotspots.propTypes = {
  storeId: string,
  skus: arrayOf(string),
  collectionImage: string,
  requestKey: string,
  channel: string,
  products: arrayOf(shape({})),
  hotspots: arrayOf(shape(
    {
      hsXPosition: string,
      hsYPosition: string,
      itemId: string
    }
  ))
};

ContainerHotspots.defaultProps = {
  storeId: '',
  skus: [],
  collectionImage: null,
  requestKey: null,
  channel: null,
  products: [],
  hotspots: null
};

export { ContainerHotspots };
